import { useState } from "react";

export const Pagination = ({ totalPages, setPrevious, setNext }) => {
  const [count, setCount] = useState(1);

  const handlePrevious = () => {
    if (count <= 1) {
      setCount(1);
      setPrevious(1);
    } else {
      setCount(count - 1);
      setPrevious(count - 1);
    }
  };

  const handleNext = () => {
    setCount(count + 1);
    setNext(count + 1);
  };

  let html = [];

  let pages = Math.ceil(totalPages / 10);

  for (let i = 1; i <= pages; i++) {
    html.push(
      <li className="page-item">
        <button className="page-link" onClick={() => setNext(i)}>
          {i}
        </button>
      </li>
    );
  }

  return (
    <nav aria-label="Page navigation example">
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            aria-label="Previous"
            onClick={() => handlePrevious()}
          >
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        {html}
        <li className="page-item">
          <button
            className="page-link"
            aria-label="Next"
            onClick={() => handleNext()}
          >
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </nav>
  );
};
